import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ApplicationState } from "../../store";
import { ToxnotComponent, ToxnotComponentProperties } from "../core/BaseApplicationComponents/ToxnotComponent";
import * as EngageStateController from "../../store/StateControllers/Engagement/EngagementStateController";
import { SharedMaterialCircularityData, SharedMaterialCoreData, SharedMaterialEolOption, SharedMaterialEolOptionType, SharedMaterialEolOption_DesignedForDisassembly, SharedMaterialEolOption_DesignedForMaintenanceAndRepair, SharedMaterialEolOption_DesignedForReuse, SharedMaterialEolOption_Other, SharedMaterialEolOption_Recycling, SharedMaterialEolOption_TakeBackProgram } from "../../store/Models/SharedMaterials/DataModel";
import { SharedMaterialDetailDataSection } from "../SharedMaterials/Detail/SharedMaterialDetailDataSubsection";
import { FileTableEntry } from "../../store/Models/Documents/DocumentModels";
import { ToxnotReactComponentPaths } from "../core/ToxnotReactComponentPaths";

import "./styles.css"

interface ReduxConnectedState {
    engageState: EngageStateController.EngagementState;
}

type EngageComponentProps =
    ReduxConnectedState &
    ToxnotComponentProperties &
    typeof EngageStateController.actionCreators &
    RouteComponentProps<{ productName: string }>

class Engagement extends ToxnotComponent<EngageComponentProps> {
    public componentDidMount() {
        const params = this.props.match.params;
        this.props.loadEngageBundleAsync(params.productName);
    }

    // ===============================================================================

    private isLoading() {
        return this.props.engageState.isLoading;
    }

    public render() {
        if (this.isLoading()) {
            return (<div className="text-center">{"Loading..."}</div>);
        }

        if (null === this.props.engageState.bundle) {
            return (<div className="text-center">{"Sorry, there is nothing here."}</div>);
        }

        const bundle = this.props.engageState.bundle!;

        return (
            <div>
                <div id="engagement-root" style={{ overflowY: "auto" }}>
                    <div className="container">
                        <header>
                            <img src="/images/exchange/engage/assa-abloy-engage-logo.png" />
                        </header>
                    </div>
                    <div className="hero">
                        <div className="container">
                            <div className="content">
                                <div className="text-content">
                                    <h1>Our long-term commitment to a sustainable future</h1>
                                    <p className="blurb">ASSA ABLOY Opening Solutions is the global leader in door opening solutions dedicated to satisfying end-user needs for security, safety and convenience. As an extension to providing quality products, ASSA ABLOY is committed to mindful design, manufacturing, and disposal processes that protect the planet’s natural resources. This program provides customers with environmentally friendly options for recycling, reusing, or disposing of ASSA ABLOY Opening Solutions products that have reached the end of their life cycle and are beyond their warranty period.</p>
                                    <p className="product-name">{bundle.coreData.materialName}</p>
                                    <p className="sku">SKU {bundle.coreData.sku}</p>
                                    <p>
                                        <button type="button" className="btn engagement-button-complement" onClick={e => this.openModal()}>Connect with ASSA ABLOY <span className="glyphicon glyphicon-chevron-right"></span></button>
                                    </p>
                                </div>
                                <div className="image-content">
                                    {(bundle.coreData.materialPhotoFileId !== null) && <img src={`/Api/GeneralFileImage?fileId=${encodeURIComponent(bundle.coreData.materialPhotoFileId)}&overrideTeamOwnerId=${encodeURIComponent(bundle.company.ownerId)}`} />}
                                </div>
                            </div>
                        </div>
                        <div className="section-separator"></div>
                    </div>
                    <div className="container">
                        {null != bundle.detailBundle.detailData.restrictedData!.circularity &&
                            this.renderCircularity(bundle.detailBundle.detailData.restrictedData!.circularity!, bundle.coreData, bundle.detailBundle.fileTable)}
                        <div id="passport-link-container">
                            <Link to={ToxnotReactComponentPaths.SharedMaterialBaseDetailPath + "/" + bundle.coreData.sharedMaterialId} role="button" className="btn engagement-button-complement">{this.localizeString("Check out our Product Passport on the Passport Library")} <span className="glyphicon glyphicon-chevron-right"></span></Link>
                        </div>
                        <footer>
                            <span>Powered by</span><span><a href="https://exchange.3eco.com"><img src="/images/exchange/footer-toxnot.png" /></a></span>
                        </footer>
                    </div>
                </div>
                <div className="modal fade" id="connect-form-modal" tabIndex={-1} role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h3 className="modal-title">{this.localizeString("Connect with ASSA ABLOY")}</h3>
                            </div>
                            <div className="modal-body">
                                <div id="connect-form-body">
                                    <div className="alert alert-info">
                                        Thank you for your interest in and commitment to optimized products. For additional information or to speak with an ASSA ABLOY subject matter expert, please complete the form below.
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("Name")}</label>
                                        <input className="form-control" id="connect-name" type="text" />
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("Email")}</label>
                                        <input className="form-control" id="connect-email" type="text" />
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("Product Type(s)")}</label>
                                        <input className="form-control" id="connect-product-type" type="text" />
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("Project Name")}</label>
                                        <input className="form-control" id="connect-project-name" type="text" />
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("Location")}</label>
                                        <input className="form-control" id="connect-location" type="text" />
                                    </div>
                                    <div className="form-group">
                                        <label>{this.localizeString("More Information (optional)")}</label>
                                        <textarea rows={6} className="form-control" id="connect-more-information"></textarea>
                                    </div>
                                </div>
                                <div className="alert alert-warning" id="connect-form-empty-fields" style={{ display: "none" }}>
                                    {this.localizeString("The Name, Contact Email, Product Types and the Location fields cannot be empty.")}
                                </div>
                                <div className="alert alert-danger" id="connect-form-invalid-email" style={{ display: "none" }}>
                                    {this.localizeString("Please enter a valid email address.")}
                                </div>
                                <div className="alert alert-success" id="connect-form-success" style={{ display: "none" }}>
                                    {this.localizeString("Your information was sent to ASSA ABLOY.")}
                                </div>
                                <div className="alert alert-danger" id="connect-form-error" style={{ display: "none" }}>
                                    {this.localizeString("Sorry, there was a problem accessing the service.")}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" id="cancel-connect-form-button" data-dismiss="modal" >{this.localizeString("Cancel")}</button>
                                <button type="button" className="btn btn-default" style={{ display: "none" }} id="close-connect-form-button" data-dismiss="modal" >{this.localizeString("Close")}</button>
                                <button type="button" className="btn btn-primary" id="send-email-button" onClick={e => this.props.sendConnectWithForm(this.props.appServices)}>{this.localizeString("Send")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderCircularity(data: SharedMaterialCircularityData, coreData: SharedMaterialCoreData, fileTable: { [fileId: string]: FileTableEntry; }) {
        const bundle = this.props.engageState.bundle!;
        return (
            <React.Fragment>
                {data.eolOptions.map(option =>
                    <div key={option.type} className="eol-option-container">
                        <div className="header">
                            <div className="title">
                                {this.resolveEolName(option.type)}
                            </div>
                            <div className="description">
                                {option.description}
                            </div>
                        </div>
                        <div className="content">
                            {(option.supportingLink.length > 0) && <p><a role="button" onClick={e => this.clickEolOptionSupportingLink(option)}>{option.supportingLink}</a></p>}
                            {option.attachmentFileIds.map((fileId, index) =>
                                SharedMaterialDetailDataSection.renderDocument(fileId, index, fileTable, coreData.implementationInventoryId, "engagement-document-download", { optionType: option.type, materialId: bundle.coreData.sharedMaterialId, productName: bundle.coreData.materialName, ownerId: bundle.coreData.ownerId }, this.props.appServices)
                            )}
                            {this.resolveEolOptionRenderer(option)}
                        </div>
                    </div> )}
            </React.Fragment>
        );
    }

    private clickEolOptionSupportingLink(option: SharedMaterialEolOption) {
        const bundle = this.props.engageState.bundle!;
        this.props.appServices.trackEvent("engagement-eol-option-supporting-link-click", { optionType: option.type, materialId: bundle.coreData.sharedMaterialId, productName: bundle.coreData.materialName, ownerId: bundle.coreData.ownerId });
        window.open(option.supportingLink);
    }

    private resolveEolName(type: SharedMaterialEolOptionType): string {
        switch (type) {
            case SharedMaterialEolOptionType.DesignedForMaintenanceAndRepair: return "Designed for Maintenance and Repair";
            case SharedMaterialEolOptionType.DesignedForDisassembly: return "Designed for Disassembly";
            case SharedMaterialEolOptionType.DesignedForReUse: return "Designed for Re-use";
            case SharedMaterialEolOptionType.TakeBackProgram: return "Take Back Program";
            case SharedMaterialEolOptionType.Recycling: return "Recycling Instructions";
            case SharedMaterialEolOptionType.Other: return "Other";
            default: return "?";
        }
    }

    private resolveEolOptionRenderer(option: SharedMaterialEolOption): JSX.Element {
        switch (option.type) {
            case SharedMaterialEolOptionType.DesignedForMaintenanceAndRepair: return this.renderEolOption_DesignedForMaintenanceAndRepair(option);
            case SharedMaterialEolOptionType.DesignedForDisassembly: return this.renderEolOption_DesignedForDisassembly(option);
            case SharedMaterialEolOptionType.DesignedForReUse: return this.renderEolOption_DesignedForReUse(option);
            case SharedMaterialEolOptionType.TakeBackProgram: return this.renderEolOption_TakeBackProgram(option);
            case SharedMaterialEolOptionType.Recycling: return this.renderEolOption_Recycling(option);
            case SharedMaterialEolOptionType.Other: return this.renderEolOption_Other(option);
        }
    }

    private renderEolOption_DesignedForMaintenanceAndRepair(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_DesignedForMaintenanceAndRepair;
        return (
            <div className="options-list-container">
                <ul>
                    {option.maintainedByUntrained && <li>{"The product can be maintained & repaired by untrained personnel at the location of the product use"}</li>}
                    {option.maintainedByTrained && <li>{"The product can be maintained & repaired by trained personnel at the location of the product use"}</li>}
                    {option.maintenanceNotRequired && <li>{"The product requires no maintenance or repair if the intended use of the product is followed"}</li>}
                    {option.maintenanceNotPossible && <li>{"Maintenance or repair of the product during its use period is not possible due to the design of the product"}</li>}
                    {option.consumableReplacedByUntrained && (<li>{"Consumables are easily replaced by untrained personnel"}</li>)}
                    {option.sparePartsAvailable && (<li>{"Spare parts are made available by the manufacturer or an authorized representative during the functional use period of the product"}</li>)}
                </ul>
            </div>
        );
    }

    private renderEolOption_DesignedForDisassembly(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_DesignedForDisassembly;
        return (
            <div>
                <p>
                    {"Disassembly Instructions"}:
                </p>
                {option.instructions.split('\n').map((s, index) => (
                    <p key={index}>
                        {s.trim()}
                    </p>
                ))
                }
            </div>
        );
    }

    private renderEolOption_DesignedForReUse(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_DesignedForReuse;
        var hasOptionGroup1 = option.minimalModification || option.ceMark || option.refurbishment || option.remanufacturing;
        var hasOptionGroup2 = option.dedicatedCollectionSystem || option.emitted || option.industrialCascading ||
            option.industrialComposter || option.homeComposter || option.biodegestion || option.incineration;
        return (
            <React.Fragment>
                <div className="options-list-container">
                    <ul>
                        {option.minimalModification && <li>{"The product is designed for re-use as-is or with minimal modification"}</li>}
                        {option.ceMark && <li>{"The product has the CE mark"}</li>}
                        {option.refurbishment && <li>{"The product is designed for refurbishment"}</li>}
                        {option.remanufacturing && <li>{"The product is designed for remanufacturing"}</li>}
                        {(hasOptionGroup1 && hasOptionGroup2) && <p />}
                        {option.dedicatedCollectionSystem && <li>{"The manufacturer/ industry association has a dedicated collection system in place to gather and deliver products for recycling"}</li>}
                        {option.emitted && <li>{"The portion of the product known to be emitted into the environment during use is designed for that purpose"}</li>}
                        {option.industrialCascading && <li>{"The product is designed for industrial cascading in the biosphere"}</li>}
                        {option.industrialComposter && <li>{"The product is designed for composting in an industrial facility"}</li>}
                        {option.homeComposter && <li>{"The product is designed for composting in a home composter"}</li>}
                        {option.biodegestion && <li>{"The product is designed for clean biodigestion"}</li>}
                        {option.incineration && <li>{"The product is designed for clean incineration/pyrolysis"}</li>}
                    </ul>
                </div>
                <div>
                    <p>
                        {"What % of the product is designed for recycling at the same level of quality. The remainder of the materials is foreseen by the manufacturer to be recycled at a lower quality than the original content"}:
                    </p>
                    <p>
                        {option.recyclingPercent}
                    </p>
                </div>
                <div>
                    <p>
                        {"What % of the product content is anticipated to become leakage during the use phase due to for example wear & tear, oxidation, erosion, etc"}:
                    </p>
                    <p>
                        {option.leakagePercent}
                    </p>
                </div>
            </React.Fragment>
        );
    }

    private renderEolOption_TakeBackProgram(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_TakeBackProgram;
        return (
            <div>
                {option.instructions}
            </div>
        );
    }

    private renderEolOption_Recycling(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_Recycling;
        return (
            <div>
                {option.instructions}
            </div>
        );
    }

    private renderEolOption_Other(rawOption: SharedMaterialEolOption) {
        var option = rawOption as SharedMaterialEolOption_Other
        return (
            <div>
                {"Name"}: {option.name}
            </div>
        );
    }

    private openModal() {
        $("#connect-form-body").show();
        $("#connect-form-success").hide();
        $("#connect-form-error").hide();
        $("#connect-form-invalid-email").hide();
        $("#connect-form-empty-fields").hide();
        $("#connect-form-missing-location").hide();
        $("#connect-form-missing-product-type").hide();
        $("#send-email-button").show();
        $("#close-connect-form-button").hide();
        $("#cancel-connect-form-button").show();
        $("#connect-form-modal").modal("show");
    }
}

// ===============================================================================

export default connect(
    // Selects which state properties are merged into the component's props
    (state: ApplicationState) => ({
        engageState: state.engageState,
        appServices: state.appServices
    }),
    EngageStateController.actionCreators // Selects which action creators are merged into the component's props
)(withRouter(Engagement) as any);
